// This helper allows us to abstract the Browser native API
// so that we can easily mock the navigation in our tests
export const navigateTo = (url: string) => {
  location.assign(url);
};
